"use strict";
// This map will only include payment methods which are to be added for a particular region only
// and not for all regions with a particular currency. If a payment method is to be switched on for
// all regions for the currency (i.e. currencywide) add the payment method in currencies.ts instead
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodLimitsByRegion = void 0;
exports.paymentMethodLimitsByRegion = {
    luxuryescapes: {
        AU: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 2971, // merchant fee subtracted from 3000
            },
        ],
        US: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 4000,
            },
        ],
        NZ: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 4000,
            },
        ],
        GB: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 2000,
            },
        ],
        DE: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 10000,
            },
        ],
        FR: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 1500,
            },
        ],
        IE: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 1500,
            },
        ],
        IT: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 1500,
            },
        ],
        ES: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 1500,
            },
        ],
        NL: [
            {
                paymentMethod: "stripe_payment_element_klarna",
                limit: 4000,
            },
        ],
    },
};
